import { useMutation, useQuery } from "@tanstack/react-query";
import { IActionResponse, IActionResult } from "../../../../assets/utils/lib";

import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { Constants } from "../../../../assets/utils/lib/constants";
import { SearchOrganizationDto } from "./organizationPage";
import { NonprofitOrganizationClient } from "../../../../services/proxies/community/NonprofitOrganizationClient";
import { OrganizationDto } from "../../../../services/dto/nonprofit/organizationDto";

export namespace NonprofitOrganizationService {
    const nonprofitOrganizationClient = new NonprofitOrganizationClient();

    export const save = () =>
        useMutation<IActionResult<OrganizationDto>, Error, OrganizationDto>({
            mutationFn: async (payload: OrganizationDto) => {
                return await nonprofitOrganizationClient.saveNonprofitOrganizationAsync(
                    payload
                );
            },
        });

    export const getNonprofitOrganizationQuery = (id: string | undefined) =>
        useQuery({
            queryKey: ["nonprofitOrganizationQuery", id],
            queryFn: async () =>
                await nonprofitOrganizationClient.getNonprofitOrganizationAsync(id),
            enabled: Boolean(id && id !== Constants.emptyGuid),
        });

    export const gridQuery = (searchQuery: SearchOrganizationDto) =>
        useQuery({
            queryKey: ["nonprofitOrganizationGridQuery", searchQuery],
            queryFn: async () =>
                await nonprofitOrganizationClient.searchNonprofitOrganizationsAsync(
                    searchQuery
                ),
            enabled: Boolean(
                searchQuery.communityId && searchQuery.communityId !== Constants.emptyGuid
            ),
            placeholderData: (previousData) => previousData,
        });

    export const getLookups = () =>
        useQuery({
            queryKey: ["nonprofitOrganizationLookupsQuery"],
            queryFn: async () => await nonprofitOrganizationClient.getLookupsAsync(),
            select: (data) => {
                return {
                    communities: LookupDto.mapToOptions(data?.community),
                    state: data?.state,
                    county: data?.county,
                    category: LookupDto.mapToOptions(data?.category),
                };
            },
        });

    export const deleteOrganization = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await nonprofitOrganizationClient.deleteOrganizationAsync(id);
            },
        });

    export const deActivateOrganization = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (organizationId: string | undefined) =>
                await nonprofitOrganizationClient.deActivateNonprofitOrganizationAsync(
                    organizationId
                ),
        });
}